

export const ON_SET = 'ON_SET';
export const updatePreferredClickCollectAddress = (value) => ({
    type: ON_SET,
    payload: {
        value
    },
}
);
